module.exports = __webpack_public_path__ + "img/add-friend.898df5a1.png";